import styled from 'styled-components';
import {Container} from 'react-bootstrap';

const ItemContainer = styled(Container)`
  padding-top: ${props => props.theme.padding.item.standard};
  padding-bottom: ${props => props.theme.padding.item.standard};
`

export default ItemContainer;